"use client";

import { useEffect, useState } from "react";
import { apiBinary } from "@/lib/api";
import { cn } from "@/lib/utils";

const photoBlobCache = new Map<string, Promise<string>>();

function authedPhotoUrl(src: string) {
  const cached = photoBlobCache.get(src);
  if (cached) return cached;
  const pending = apiBinary(src).then((blob) => URL.createObjectURL(blob));
  photoBlobCache.set(src, pending);
  return pending;
}

export function AuthedImage({
  src,
  alt,
  className,
}: {
  src: string;
  alt: string;
  className?: string;
}) {
  const [url, setUrl] = useState<string | null>(() =>
    src.startsWith("blob:") || src.startsWith("data:") ? src : null,
  );

  useEffect(() => {
    if (src.startsWith("blob:") || src.startsWith("data:")) {
      setUrl(src);
      return;
    }
    let cancelled = false;
    setUrl(null);
    void authedPhotoUrl(src)
      .then((next) => {
        if (!cancelled) setUrl(next);
      })
      .catch(() => {
        if (!cancelled) setUrl(null);
      });
    return () => {
      cancelled = true;
    };
  }, [src]);

  if (!url) {
    return <div className={cn("min-h-8 bg-accent", className)} aria-hidden />;
  }

  return (
    // eslint-disable-next-line @next/next/no-img-element
    <img src={url} alt={alt} className={className} draggable={false} />
  );
}
